export default function Logo({ className = "h-9 w-9" }) {
  return (
    <img
      src="/brand/fix-logo.png"
                alt="Service LCD Macbook Murah Jakarta"
                className="h-16 w-auto"
                data-testid="hero-image"
    />
  );
}